/**
 * Smooth Scroll Script for in-page navigation
 * For the seasonings landing page funnel
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all navigation links that have hash links
  const navLinks = document.querySelectorAll('a[href^="#"]');
  
  // Add click event listener to each navigation link
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Only process if the link has a hash
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      
      // Only proceed if the target element exists
      if (targetElement) {
        e.preventDefault();
        
        // Get header height for offset calculation
        const headerHeight = document.querySelector('.header') 
          ? document.querySelector('.header').offsetHeight 
          : 0;
          
        // Calculate the target position with offset for header
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = targetPosition - headerHeight;
        
        // Smooth scroll to the target
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // Close mobile menu if it's open
        const mobileMenu = document.querySelector('.header__nav');
        if (mobileMenu && mobileMenu.classList.contains('active')) {
          mobileMenu.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
    });
  });
  
  // Mobile menu toggle functionality
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileClose = document.querySelector('.header__mobile-close');
  const nav = document.querySelector('.header__nav');
  
  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function() {
      nav.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (mobileClose && nav) {
    mobileClose.addEventListener('click', function() {
      nav.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
}); 